import {ReactNode} from 'react';
import useUserFromConfirmationToken from '@/public/hooks/useUserFromConfirmationToken';
import ApiSuspense from '@/shared/components/ApiSuspense';
import {useUserContext} from '@/shared/contexts/UserContext/useUserContext';
import CompanyContext from './CompanyContext';
import useGetCompanyFromPublicIdentifier from './hooks/useGetCompanyFromPublicIdentifier';

export default function CompanyContextProvider({children}: {children: ReactNode}) {
  const {company} = useUserContext();
  const query = useUserFromConfirmationToken();
  const companyQuery = useGetCompanyFromPublicIdentifier();

  const companyFromConfirmationToken = query?.data?.data ? query?.data?.data.company : null;

  const element = (
    <CompanyContext.Provider
      value={company ?? companyFromConfirmationToken ?? companyQuery?.data?.data ?? null}
    >
      {children}
    </CompanyContext.Provider>
  );

  if (query) {
    const isTokenQueryPending = query.isPending && query.fetchStatus !== 'idle';

    return (
      <ApiSuspense
        apiQueryStatus={{
          isPending: isTokenQueryPending,
          isError: false,
          isIdle: query.fetchStatus === 'idle'
        }}
      >
        {() => element}
      </ApiSuspense>
    );
  } else if (companyQuery) {
    return (
      <ApiSuspense
        apiQueryStatus={{
          isPending: companyQuery.isPending,
          isError: companyQuery.isError,
          isIdle: companyQuery.fetchStatus === 'idle'
        }}
      >
        {() => element}
      </ApiSuspense>
    );
  } else {
    return element;
  }
}
